module.exports = __webpack_public_path__ + "static/img/93.4518ed1.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/digital/news/93.png
// module id = mZLh
// module chunks = 0